import { useSelector } from 'react-redux';
import UserDuck from '../redux/user/user.duck';
import { useMemo } from 'react';
import { IConfigurableCar } from '../interfaces/Car';
import { PxStatus } from '../partExchange/constants/config';

export const OrderCompletedMopLastStepCode = 2200;

export type PxPendingUpload = {
    mopId: string;
    pxId: string;
    configuration: IConfigurableCar;
};

export const usePxPendingUploads = () => {
    const orders = useSelector(state => UserDuck.getOwnState(state).myOrders.items);

    const pxPendingUploads = useMemo(() => {
        const pendingUploads: PxPendingUpload[] = [];

        if (orders) {
            orders.map(order => {
                if (
                    order &&
                    order.sibling &&
                    order.sibling.extraFields &&
                    order.sibling.extraFields.partExchangeStatusId === PxStatus.PICTURE &&
                    order.sibling.extraFields.mopLastStepCode === OrderCompletedMopLastStepCode
                ) {
                    pendingUploads.push({
                        mopId: order.sibling.mopId,
                        pxId: order.sibling.partExchange,
                        configuration: order.sibling.fullProductConfiguration,
                    });
                }
            });
        }
        return pendingUploads;
    }, [orders]);

    return { pxPendingUploads };
};
